import type { IconSizeType } from "@next-platform/client-common-spicy-ui";
import { Icon, IconSize } from "@next-platform/client-common-spicy-ui";
import type { MeterType } from "@next-platform/packages-ts-types";
import React from "react";

import { resolveMeterIcon } from "@/components/Rulebook/meterIcons";

type RulebookMeterIconProps = {
  icon?: string;
  meterType: MeterType;
  color?: string;
  size?: IconSizeType;
  "data-testid"?: string;
};

const RulebookMeterIcon = ({
  icon,
  meterType,
  color,
  size = IconSize.SMALL,
  "data-testid": testId = "RulebookMeterIcon",
}: RulebookMeterIconProps) => (
  <span data-testid={testId} className="inline-flex shrink-0" aria-hidden={true}>
    <Icon icon={resolveMeterIcon({ icon, meterType })} size={size} color={color ?? "currentColor"} />
  </span>
);

export default React.memo(RulebookMeterIcon);
